<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <h5>Регулярные и разовые планы перемещений на склады</h5>
        <div class="row">
          <div class="col-md-4">
            <DateSelectProps
              :disabled="true"
              :disabledDatesBefore="disabledDates"
              :selectedDate="null"
              :onSelect="(date) => this.newSendTime = date"
            />
            <div>
              {{ preSets }}
            </div>
          </div>
          <div class="col-md-8 flex">
            <multiselect
              name="user_role"
              v-model="newReceivers"
              :noShotCuts="true"
              :options="Object.values($AllStores).filter((s) => s.is_active && ![1,2,3,4].includes(s.id))"
              placeholder="Выберите города"
              track-by="title"
              label="title"
              :showLabels="false"
              :searchable="false"
              :multiple="true">
            </multiselect>
            <button @click="addCustomDelivery" class="btn btn-primary">Добавить</button>
          </div>
        </div>
        <div v-if="customDelivery && customDelivery.length">
          <hr>
          <table class="table table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Дата/Время отправки</th>
              <th>Дата/Время прибытия</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(delivery, index) in customDelivery">
              <td><strong>{{ $AllStores[delivery.receive_store_id].short_title }}</strong></td>
              <td>{{ delivery.send_date }}</td>
              <td>
                <DateTimeSelect
                  :onSelect="(date) => customDelivery[index].delivery_date = date"
                  :selectedDate="delivery.delivery_date"
                  :useDisabledDates="new Date()"
                  :disabled="true"
                />
              </td>
              <td>
                <button class="btn btn-danger">
                  <i @click="deleteRecord(delivery.id, index, 'custom')" class="icon-fa icon-fa-trash"/>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="!loading">
      <div v-if="records && records.length > 0">
        <div class="card" v-for="store in $AllStores" v-if="store.is_active && ![1,2,3,4].includes(store.id)">
          <div class="card-body">
            <div class="flex justify-content-between">
              <div>
                <strong>{{ store.short_title }}</strong>
              </div>
              <template v-if="false && storeSettings[store.id]">
                <div>
                  <label for="">Количество дней в пути</label>
                  <input type="number" v-model="storeSettings[store.id].days" class="form-control">
                </div>
                <div>
                  <label for="">Время прибытия</label>
                  <TimeSelect
                    :selectedDate="storeSettings[store.id].time"
                    :onSelect="(date) => storeSettings[store.id].time = date"
                    :disabled="true"
                  />
                </div>
              </template>
              <div class="">
                <button @click="addNewRecord(store.id)" class="btn btn-outline-success" style="bottom:0">Добавить отправление</button>
              </div>
              <!--              <div class="form-group">-->
              <!--                <input type="checkbox" :id="`ch_${store.id}`" v-model="storeSettings[store.id].active">-->
              <!--                <label :for="`ch_${store.id}`">Отправка активна</label>-->
              <!--              </div>-->
            </div>
            <template v-if="sortedRecords[store.id]">
              <table class="table table-hover table-sm mt-1">
                <thead>
                <tr>
                  <th>День недели отправки</th>
                  <th>Количество дней в пути</th>
                  <th>Время прибытия</th>
                  <th>Активно</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(record, index) in [...(sortedRecords[store.id] || [])]">
                  <td v-bind:class="{not_active: !record.regular_delivery}">
                    <select v-model="record.day_num" class="form-control">
                      <option value="1">Понедельник</option>
                      <option value="2">Вторник</option>
                      <option value="3">Среда</option>
                      <option value="4">Четверг</option>
                      <option value="5">Пятница</option>
                      <option value="6">Суббота</option>
                      <option value="7">Воскресенье</option>
                    </select>
                  </td>
                  <td v-bind:class="{not_active: !record.regular_delivery}">
                    <input type="number" v-model="record.day_duration" class="form-control">
                  </td>
                  <td v-bind:class="{not_active: !record.regular_delivery}">
                    <TimeSelect
                      :selectedDate="record.delivery_time"
                      :onSelect="(date) => record.delivery_time = date"
                      :disabled="true"
                    />
                  </td>
                  <td>
                    <input type="checkbox" :id="`ch_${record.id}`" v-model="record.is_active">
                  </td>
                  <td>
                    <button class="btn btn-danger">
                      <i @click="deleteRecord(record.id, index, 'regular', store.id)" class="icon-fa icon-fa-trash"/>
                    </button>
                    <!--                    <input type="checkbox" v-model="record.regular_delivery">-->
                  </td>
                </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <LoadingButton
        title="Сохранить"
        className="btn btn-success"
        :onClick="() => saveRecords()"
        :loading="saveLoading"
        :color="$constants.SUCCESS_COLOR"
      />
    </div>
  </div>
</template>

<script>

import api from "@/api"
import DateSelectProps from "@/views/reports/components/DateSelectProps";
import DatePicker from "vue2-datepicker";
import TimeSelect from "@/components/dateSelect/TimeSelect";
import DateTimeSelect from "@/components/dateSelect/DateTimeSelect";
import Multiselect from 'vue-multiselect'
import moment from "moment"
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {DateTimeSelect, TimeSelect, DateSelectProps, DatePicker, Multiselect, LoadingButton},
  data() {
    return {
      loadingBtn: false,
      newSendTime: null,
      newReceivers: [],
      loading: false,
      saveLoading: false,
      customDelivery: [],
      storesTransitsDirections: null,
      receiveStores: [],
      sendStoreId: 3,
      receiveStoreId: null,
      sortedRecords: {},
      records: [],
      storeSettings: {},
      toDelete: [],
      disabledDates: new Date(),
      preSets: [],
    }
  },
  computed: {
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
  mounted() {
    this.updatePreSets();
    this.getStores();
    this.getRecords();
  },
  methods: {
    updatePreSets() {
      this.preSets = [];
      this.preSets.push({
        title: 'ЕКБ-ТНМ-НВС-КРА-ЯСК',
        // selected:
      })
    },
    deleteRecord(id, index, type, storeId = null) {
      if (type === 'custom') {
        let records = [...this.customDelivery];
        if (id) {
          this.toDelete.push(id);
          records = records.filter((d) => d.id !== id);
        } else {
          delete records[index];
          records = records.filter((d) => d);
        }
        this.customDelivery = [...records];
      } else {
        console.log(id, index, type, storeId);
        let records = {...this.sortedRecords};
        if (id) {
          this.toDelete.push(id);
          records[storeId] = records[storeId].filter((d) => d.id !== id);
        } else {
          delete records[storeId][index];
          records[storeId] = records[storeId].filter((d) => d);
        }
        this.sortedRecords = {...records};
      }
    },
    addCustomDelivery() {
      if (!this.newReceivers || !this.newReceivers.length || !this.newSendTime) return;
      const newCustomDelivery = this.newReceivers.reduce((acc, s) => {
        const record = {};
        record.send_store_id = this.sendStoreId;
        record.delivery_time = this.storeSettings[s.id].time;
        record.receive_store_id = s.id;
        record.regular_delivery = false;
        if (this.storeSettings[s.id]) {
          const dDate = moment(this.newSendTime);
          dDate.add(this.storeSettings[s.id].days, 'days');
          const time = this.storeSettings[s.id].time.split(':');
          dDate.set({"hour": time[0], "minute": time[1]});
          record.delivery_date = dDate.format('YYYY-MM-DD HH:mm:00');
        } else {
          record.delivery_date = moment().format('YYYY-MM-DD HH:mm:00');
        }
        record.send_date = this.newSendTime;
        acc.push(record);
        return acc;
      }, []);
      this.newReceivers = null;
      this.newSendTime = null;
      this.customDelivery = [...this.customDelivery, ...newCustomDelivery];
    },
    addNewRecord(storeId) {
      // if (!this.sendStoreId || !this.receiveStoreId) return;
      if (!this.sortedRecords[storeId]) {
        this.sortedRecords[storeId] = []
      }
      // if (!this.sortedRecords[storeId].regular) {
      //   this.sortedRecords[storeId].regular = [];
      // }
      this.sortedRecords[storeId].push({
        send_store_id: this.sendStoreId,
        receive_store_id: storeId,
        send_date: null,
        send_time: null,
        day_num: 1,
        day_duration: this.storeSettings[storeId] && this.storeSettings[storeId].days || 1,
        delivery_time: this.storeSettings[storeId] && this.storeSettings[storeId].time || null,
        delivery_date: null,
        regular_delivery: true,
      });
      this.sortedRecords = {...this.sortedRecords};
    },
    updateReceiveStore() {
      this.receiveStores = Object.keys(this.storesTransitsDirections[this.sendStoreId]);
      this.receiveStoreId = this.receiveStores[0];
    },
    async getStores() {
      this.loading = true;
      const {data} = await api.index('/invoices/stores');
      if (data.success) {
        this.storesTransitsDirections = data.storesTransitsDirections;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    },
    async getRecords() {
      this.saveLoading = true;
      const {data} = await api.index('/invoices/planedTransfers');
      if (data.success) {
        this.storeSettings = data.settings;
        this.records = data.records;
        this.customDelivery = data.customDelivery;
        this.updateSortedRecords();
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.saveLoading = false;
    },
    async saveRecords() {
      this.saveLoading = true;
      const {data} = await api.post('/invoices/planedTransfers', {
        records: Object.values(this.sortedRecords).reduce((acc, r) => {
          acc = [...acc, ...r];
          return acc;
        }, []),
        settings: this.storeSettings,
        toDelete: this.toDelete,
        customDelivery: this.customDelivery
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено!');
        await this.getRecords();
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.saveLoading = false;
    },
    updateSortedRecords() {
      this.sortedRecords = this.records.reduce((acc, r) => {
        // const title = r.regular_delivery ? 'regular' : 'custom';
        // if (!acc[r.receive_store_id]) {
        //   acc[r.receive_store_id] = {};
        // }
        if (!acc[r.receive_store_id]) {
          acc[r.receive_store_id] = [];
        }
        acc[r.receive_store_id].push(r);
        return acc;
      }, {})
    },
    updateReceiveTime(date, record, storeId, index) {
      record.send_date = date;
      if (this.storeSettings[storeId]) {
        const newDate = moment(date);
        newDate.add(this.storeSettings[storeId].days, 'days');
        const time = this.storeSettings[storeId].time.split(':');
        newDate.set({"hour": time[0], "minute": time[1]});
        record.delivery_date = newDate.format('YYYY-MM-DD HH:mm:00');
        this.$refs[`deliveryDate_${storeId}_${index}`][0].displayDate = newDate.format('DD.MM.YYYY HH:mm');
      }
    }
  }
}
</script>

<style scoped>
.not_active {
  opacity: .1;
}

.btn i {
  text-align: center;
}
</style>
